import { render, staticRenderFns } from "./demographic-data.component.vue?vue&type=template&id=088bc9b1&"
import script from "./demographic-data.component.ts?vue&type=script&lang=ts&"
export * from "./demographic-data.component.ts?vue&type=script&lang=ts&"
import style0 from "./demographic-data.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports